import { ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

type Props = {
  containerId?: string;
  children?: ReactNode;
  onRequestClose?: () => void;
};

const Modal = ({ containerId = 'root', children, onRequestClose }: Props) => {
  const portalContainer = document.createElement('div');
  portalContainer.setAttribute('data-js-modal-container', '');
  useEffect(() => {
    const root = document.getElementById(containerId);
    root?.appendChild(portalContainer);
    return () => {
      root?.removeChild(portalContainer);
    };
  });

  return createPortal(
    <div className={styles.backdrop} onClick={onRequestClose}>
      <div
        className={styles['modal-container']}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {children}
        <button onClick={onRequestClose} className={styles.close}>
          <FontAwesomeIcon icon={faXmark} className={styles.icon} />
        </button>
      </div>
    </div>,
    portalContainer
  );
};
export default Modal;
